export const SUBMIT_DEPOSIT = 'PAYMENTS/SUBMIT_DEPOSIT/SUBMIT'
export const SUBMIT_DEPOSIT_SUCCESS = 'PAYMENTS/SUBMIT_DEPOSIT/SUBMIT_SUCCESS'
export const SUBMIT_DEPOSIT_ERROR = 'PAYMENTS/SUBMIT_DEPOSIT/SUBMIT_ERROR'
export const SUBMIT_DEPOSIT_CLEAR = 'PAYMENTS/SUBMIT_DEPOSIT/SUBMIT_DEPOSIT_CLEAR'
